module.exports = __webpack_public_path__ + "img/logout.ceb84df1.svg";